import { BaseDataType, FirstAidCoursesBlock } from '@/src/@types/statamic'

type FlchFallbackData = NonNullable<BaseDataType['flchFallbacks']>

export type FlchFallbackContent = {
  header_text: string | null
  seo_title: string | null
  seo_summary: string | null
  flch_page_builder: FirstAidCoursesBlock[]
}

function replacePlaceholders<T>(
  value: T,
  replacements: Record<string, string>
): T {
  if (typeof value === 'string') {
    return value.replace(
      /\{\{\s*(\w+)\s*\}\}/g,
      (match, name: string) => replacements[name] ?? match
    ) as T
  }
  if (Array.isArray(value)) {
    return value.map((item) => replacePlaceholders(item, replacements)) as T
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [
        key,
        replacePlaceholders(val, replacements),
      ])
    ) as T
  }
  return value
}

export function getFlchFallback(
  fallbacks: FlchFallbackData | null | undefined,
  category: string,
  locationName: string,
  cantonName: string
): FlchFallbackContent | null {
  if (!fallbacks) return null

  let content: FlchFallbackContent
  switch (category) {
    case 'teacher':
      content = {
        header_text: fallbacks.teacher_header_text,
        seo_title: fallbacks.teacher_seo_title,
        seo_summary: fallbacks.teacher_seo_summary,
        flch_page_builder: fallbacks.teacher_flch_page_builder,
      }
      break
    case 'firstaid':
      content = {
        header_text: fallbacks.firstaid_header_text,
        seo_title: fallbacks.firstaid_seo_title,
        seo_summary: fallbacks.firstaid_seo_summary,
        flch_page_builder: fallbacks.firstaid_flch_page_builder,
      }
      break
    case 'vku':
      content = {
        header_text: fallbacks.vku_header_text,
        seo_title: fallbacks.vku_seo_title,
        seo_summary: fallbacks.vku_seo_summary,
        flch_page_builder: fallbacks.vku_flch_page_builder,
      }
      break
    case 'pgs':
      content = {
        header_text: fallbacks.pgs_header_text,
        seo_title: fallbacks.pgs_seo_title,
        seo_summary: fallbacks.pgs_seo_summary,
        flch_page_builder: fallbacks.pgs_flch_page_builder,
      }
      break
    case 'wab':
      content = {
        header_text: fallbacks.wab_header_text,
        seo_title: fallbacks.wab_seo_title,
        seo_summary: fallbacks.wab_seo_summary,
        flch_page_builder: fallbacks.wab_flch_page_builder,
      }
      break
    default:
      return null
  }

  return replacePlaceholders(content, {
    locationName,
    cantonName,
  })
}
